
import {  appConst, Component, FormModalMixins } from "@/lib";
import IncomeDetail from "@/store/modules/foreignexchangecollection/incomedetail/entity"

@Component
export default class IncomeDetailModel extends FormModalMixins {
  model:IncomeDetail = new IncomeDetail();

  get record(){
    return this.$store.state.foreignexchangecollection.income.editDetail as IncomeDetail;
  }

  created() {
    Object.assign(this.config,{
        labelWidth: 100,
        width: 700,
        modelTitleL: "app.IncomeDetail.Detail",
        isHideOk: true
    })
  }

  get incomeType() {
    return this.getCodeDescription(appConst.codeCategory.incomeType, this.model.incomeType);
  }

  close() {
    this.config.isShow = false;
    this.model = new IncomeDetail();
  }
}

